var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetProYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_90526",
    "data-name": "Group 90526",
    transform: "translate(-0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2872",
    "data-name": "Ellipse 2872",
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(0.5)",
    fill: "#fbbe28"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(19.814 24.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90522",
    "data-name": "Group 90522",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90521",
    "data-name": "Group 90521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83263",
    "data-name": "Path 83263",
    d: "M4.094,32.284,1.021,12.311a1.666,1.666,0,0,1,2.647-1.586L13.24,17.9a2.287,2.287,0,0,0,3.276-.561l7.97-11.955a2.128,2.128,0,0,1,3.541,0L36,17.343a2.288,2.288,0,0,0,3.276.561l9.573-7.18a1.666,1.666,0,0,1,2.647,1.586L48.419,32.284Z",
    transform: "translate(-1 -4.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83264",
    "data-name": "Path 83264",
    d: "M44.852,30.559H5.148a2.311,2.311,0,0,1-2.311-2.311V23.171H47.163v5.076A2.311,2.311,0,0,1,44.852,30.559Z",
    transform: "translate(0.256 8.365)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetProYellow);
export default __webpack_public_path__ + "static/media/get-pro-yellow.5541e333e108e50c308fecdf5f89ced4.svg";
export { ForwardRef as ReactComponent };